import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase, Stethoscope, Home, BookOpen, Gift, Palette, MapPin } from 'lucide-react';
import { Card } from './ui/Card';
import { WaveDivider } from './WaveDivider';
const audiences = [{
  icon: Briefcase,
  title: 'Working Professionals',
  description: 'W-2 employees, first-time filers, and career professionals at any stage.'
}, {
  icon: Stethoscope,
  title: 'Medical Professionals',
  description: 'Nurses, physicians, travel nurses, and healthcare technicians.'
}, {
  icon: Home,
  title: 'Realtors & Agents',
  description: 'Handling commissions, 1099 income, mileage, and home office deductions.'
}, {
  icon: BookOpen,
  title: 'Teachers & Educators',
  description: 'Maximizing educator expense deductions and education credits.'
}, {
  icon: Gift,
  title: 'Inheritance Recipients',
  description: 'Guidance on tax implications, documentation, and proper reporting.'
}, {
  icon: Palette,
  title: 'Freelancers & Creatives',
  description: '1099 contractors, influencers, and side-hustle earners.'
}, {
  icon: MapPin,
  title: 'Southern California',
  description: 'Local expertise with deep understanding of CA-specific tax rules.'
}];
export function WhoThisIsFor() {
  return <section className="py-24 bg-neutral-50 relative" data-id="element-199">
      <WaveDivider position="top" color="#FFFFFF" className="absolute top-0 left-0 right-0 -mt-1" data-id="element-200" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 mt-12" data-id="element-201">
        <div className="text-center mb-16" data-id="element-202">
          <span className="text-secondary-dark font-semibold tracking-wide uppercase text-sm" data-id="element-203">
            Who We Serve
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-primary-dark mt-2 mb-4" data-id="element-204">
            Tailored Tax Solutions
          </h2>
          <p className="text-lg text-neutral-600 max-w-2xl mx-auto" data-id="element-205">
            Whether you're navigating your first tax return or managing complex
            income streams, we provide expert guidance every step of the way.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 max-w-6xl mx-auto" data-id="element-206">
          {audiences.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-207">
              <Card className="p-6 h-full flex flex-col items-center text-center hover:border-primary-light/50 transition-colors" data-id="element-208">
                <div className="w-14 h-14 bg-accent-light rounded-full flex items-center justify-center mb-4 text-primary" data-id="element-209">
                  <item.icon className="w-7 h-7" data-id="element-210" />
                </div>
                <h3 className="text-lg font-bold text-neutral-800 mb-2" data-id="element-211">
                  {item.title}
                </h3>
                <p className="text-sm text-neutral-600" data-id="element-212">{item.description}</p>
              </Card>
            </motion.div>)}
        </div>
      </div>

      <WaveDivider position="bottom" color="#FFFFFF" className="absolute bottom-0 left-0 right-0" data-id="element-213" />
    </section>;
}